export const cancellingAlertFlags = {
    newPatient: 1,
    editPatient: 2,
};

export const alertLevel = {
    warn: 1,
    error: 2,
};
